import { Tabs, Tab } from "react-bootstrap";
import { AgendamientoResumido } from "../../../services/agendamientosServicios";
import { MascotaResumida } from "../../../services/mascotasServicios";
import MascotaTable from "./MascotaTable";
import AgendamientosTable from "./AgendamientosTable";

export const TabsSection = ({
  mascotas,
  agendamientos,
  onAgregarMascotaClick,
  onAgendamientoClick,
}: {
  mascotas: MascotaResumida[];
  agendamientos: AgendamientoResumido[];
  onAgregarMascotaClick: () => void;
  onAgendamientoClick: (agendamiento: AgendamientoResumido) => void;
}) => {
  return (
    <section>
      <Tabs defaultActiveKey={"mascotas"} id="tabs-propietario">
        <Tab
          eventKey="mascotas"
          title="Mascotas"
          disabled={mascotas.length === 0}
        >
          <MascotaTable
            onAgregarMascotaClick={onAgregarMascotaClick}
            mascotas={mascotas}
          />
        </Tab>
        <Tab
          eventKey="agendamientos"
          title="Agendamientos Activos"
          disabled={agendamientos.length === 0}
        >
          <AgendamientosTable
            agendamientos={agendamientos}
            onAgendamientoClick={onAgendamientoClick}
          />
        </Tab>
      </Tabs>
    </section>
  );
};
